export default __webpack_public_path__ + "static/media/Boots of the Refectory.cf812cb8.jpg";